<script setup lang="ts">
import { ref } from 'vue'
import { sleep } from '~utils'
import { useIframe } from '~/composables/iframe/use-iframe'

const { gameURL, classIframeBackground, getIframeUrl } = useIframe()
const progressNumber = ref(10)
const isShowProgress = ref(true)
if (!gameURL.value) {
  gameURL.value = (await getIframeUrl()) as string
}
const setProgressNumber = async (): Promise<void> => {
  if (progressNumber.value >= 100) {
    clearInterval(step)
    await sleep(500)
    isShowProgress.value = false
  } else {
    progressNumber.value += 10
  }
}
const step = setInterval(setProgressNumber, 150)
</script>
<template>
  <div class="iframe-page" :class="'iframe-page--' + classIframeBackground">
    <div v-if="isShowProgress" class="iframe-page__loading">
      <NuxtImg
        format="webp"
        class="img-loading"
        src="/assets/images/sports/icon-loading-v2.png"
        alt="Logo loading"
        densities="1x"
      />
      <div class="progress-content">
        <div class="progress-content__title">Loading {{ progressNumber }}%</div>
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            :style="`width: ${progressNumber}%`"
            aria-valuenow="0"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <div class="progress-content__desc text-center">Vui lòng đợi trong giây lát</div>
      </div>
    </div>
    <ClientOnly v-else>
      <div :class="['iframe__wrapper', 'iframe__wrapper--' + classIframeBackground]">
        <iframe id="gameFrame" :src="gameURL" allowfullscreen></iframe>
      </div>
    </ClientOnly>
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/components/pages/iframe/index.scss';
</style>
